(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tennisea-city"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var opener=event.target.closest('[data-gallery-open]');if(opener){var dialog=document.getElementById(opener.getAttribute('data-gallery-open'));if(dialog&&typeof dialog.showModal==='function'){dialog.showModal();document.body.style.overflow='hidden'}}var closer=event.target.closest('[data-gallery-close]');if(closer){var active=closer.closest('dialog');if(active){active.close();document.body.style.overflow=''}}});document.addEventListener('click',function(event){if(event.target.tagName==='DIALOG'){event.target.close();document.body.style.overflow=''}});document.addEventListener('close',function(event){if(event.target.tagName==='DIALOG'){document.body.style.overflow=''}},true);document.addEventListener('click',function(event){var link=event.target.closest('a[href^="#TenniseaReviews-"]');if(link){var target=document.querySelector(link.getAttribute('href'));var details=target&&target.querySelector('.tm__review-details');if(details)details.open=true}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tennisea-launch"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-tc-gallery-open]').forEach((opener)=>{const section=opener.closest('.tc-page');const dialog=section.querySelector('[data-tc-gallery]');if(!dialog)return;const slides=[...dialog.querySelectorAll('[data-tc-slide]')];const count=dialog.querySelector('[data-tc-count]');let current=0;const show=(index)=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==current});count.textContent=(current+1)+' / '+slides.length};opener.addEventListener('click',()=>{show(0);dialog.showModal()});dialog.querySelector('[data-tc-prev]').addEventListener('click',()=>show(current-1));dialog.querySelector('[data-tc-next]').addEventListener('click',()=>show(current+1));dialog.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close()});dialog.addEventListener('keydown',(event)=>{if(event.key==='ArrowLeft')show(current-1);if(event.key==='ArrowRight')show(current+1)})});

  } catch(e) { console.error(e); }
})();
})();
